import { FormEvent, useState } from "react";
import { login } from "../lib/auth";
import { Session } from "../types";

interface LoginFormProps {
  callback: (session: Session) => void;
}

function LoginForm({ callback }: LoginFormProps) {
  let [message, setMessage] = useState<string>("");
  let [username, setUsername] = useState<string>("");
  let [password, setPassword] = useState<string>("");

  async function onLogin(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    try {
      let session: Session = await login(username, password);
      callback(session);
    } catch (err: any) {
      if (err.cause === 401) {
        setMessage("Incorrect username or password");
      } else {
        setMessage("Something went wrong. Please try again later.");
      }
    }
  }

  return (
    <form
      className="border-grayscale-800 bg-grayscale-800 flex flex-col gap-3 rounded-xl border-2 p-5 drop-shadow-lg"
      onSubmit={onLogin}
    >
      <input
        className="rounded p-2 drop-shadow-lg"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="Username"
      ></input>
      <input
        className="rounded p-2 drop-shadow-lg"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type="password"
        placeholder="Password"
      ></input>
      <p className="text-center font-bold text-red-600">{message}</p>
      <button className="rounded bg-white p-2 drop-shadow-lg" type="submit">
        Login
      </button>
    </form>
  );
}

export default LoginForm;
